/**
 * Full-page messages of the Argo access (PE-2215): an unusable link and an
 * ended service-account session. They replace whatever the route was showing
 * and offer a single way out, back to Argo. Plain DOM with `textContent`, so
 * nothing received from the network is ever interpreted as markup.
 */
export const OFC_ACCESS_PAGE_ID = 'route-ofc-access';

export const OFC_ACCESS_PAGES = Object.freeze({
  TICKET_INVALID: {
    title: 'Link scaduto',
    message:
      'Il link vale un minuto e una volta sola. Torna in Argo e premi di nuovo «Entra in Giotto».',
  },
  UNAVAILABLE: {
    title: 'Accesso non disponibile',
    message: 'Accesso non disponibile, riprova da Argo.',
  },
  SESSION_ENDED: {
    title: 'Sessione terminata',
    message:
      'La sessione è terminata. Torna ad Argo e premi di nuovo «Entra in Giotto» per continuare.',
  },
});

const hideApplication = () => {
  document
    .querySelectorAll(
      '.editor-route, .app-spinner, #navbar-private, #navbar-canvas'
    )
    .forEach((element) => {
      element.style.display = 'none';
    });
  document.getElementById('firstLoader')?.remove();
  document.body.classList.remove('canvas-route');
};

export const renderOfcAccessPage = (page, exitUrl) => {
  if (typeof document === 'undefined') return;

  hideApplication();
  document.title = `${page.title} | Giotto`;

  let container = document.getElementById(OFC_ACCESS_PAGE_ID);
  if (!container) {
    container = document.createElement('div');
    container.id = OFC_ACCESS_PAGE_ID;
    container.className = 'container';
    document.body.appendChild(container);
  }
  container.textContent = '';
  container.style.display = '';

  const card = document.createElement('div');
  card.className = 'card shadow-sm mx-auto my-5';
  card.style.maxWidth = '32rem';

  const body = document.createElement('div');
  body.className = 'card-body p-4';

  const title = document.createElement('h1');
  title.className = 'h4 mb-3';
  title.textContent = page.title;

  const message = document.createElement('p');
  message.className = 'mb-4';
  message.textContent = page.message;

  body.append(title, message);

  if (exitUrl) {
    const link = document.createElement('a');
    link.className = 'btn btn-primary';
    link.href = exitUrl;
    link.textContent = 'Torna ad Argo';
    body.append(link);
  }

  card.append(body);
  container.append(card);
};
